<!-- Annotation Label Form -->
@if (annotationLabelForm) {
  <medsurf-design-form-control-form
    [formGroup]="annotationLabelForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.text">
      </h4>
      <!-- Hidden -->
      <medsurf-design-form-control-input-switch [hidden]="(slideAuthorFacade.currentSelectedSlideFreeFormIsInteractiveArea$ | async) === false"
        [control]="annotationLabelForm.controls.hidden"
        [label]="'global.hide_label_in_viewer'"
        [class]="'w-full'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
      <!-- Text Color -->
      <medsurf-design-form-control-input-color-picker [hidden]="(slideAuthorFacade.currentSelectedSlideFreeFormIsLine$ | async) === true || (slideAuthorFacade.currentSelectedSlideFreeFormIsFree$ | async) === true"
        [control]="annotationLabelForm.controls.color"
        [label]="'global.text_color'"
        [class]="'w-full'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
      <!-- Border -->
      <medsurf-design-form-control-input-switch [hidden]="(slideAuthorFacade.currentSelectedSlideFreeFormIsLine$ | async) === true || (slideAuthorFacade.currentSelectedSlideFreeFormIsFree$ | async) === true"
        [control]="annotationLabelForm.controls.border"
        [label]="'global.with_border'"
        [class]="'w-full'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
      <!-- Border Color -->
      <medsurf-design-form-control-input-color-picker [hidden]="annotationLabelForm.value.border === false || (slideAuthorFacade.currentSelectedSlideFreeFormIsLine$ | async) === true || (slideAuthorFacade.currentSelectedSlideFreeFormIsFree$ | async) === true"
        [control]="annotationLabelForm.controls.borderColor"
        [label]="'global.border_color'"
        [class]="'w-full'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
      <!-- Border Width -->
      <medsurf-design-form-control-input-number [hidden]="annotationLabelForm.value.border === false || (slideAuthorFacade.currentSelectedSlideFreeFormIsLine$ | async) === true || (slideAuthorFacade.currentSelectedSlideFreeFormIsFree$ | async) === true"
        [control]="annotationLabelForm.controls.borderWidth"
        [label]="'global.border_width'"
        [class]="'w-full'"
        [min]="1"
        [max]="100"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
    </div>
  </medsurf-design-form-control-form>
}

<!-- Annotation Label Background Form -->
@if (annotationLabelBackgroundForm) {
  <medsurf-design-form-control-form
    [hidden]="(slideAuthorFacade.currentSelectedSlideFreeFormIsLine$ | async) === true || (slideAuthorFacade.currentSelectedSlideFreeFormIsFree$ | async) === true"
    [class]="'w-full'"
    [formGroup]="annotationLabelBackgroundForm"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <!-- Background -->
      <medsurf-design-input-switch [model]="annotationLabelBackgroundForm.value.opacity !== 0"
        [label]="'global.with_background'"
        [class]="'w-full'"
        [name]="'with_background'"
      (valueChange)="onShowBackground()"></medsurf-design-input-switch>
      <!-- Background Color -->
      <medsurf-design-form-control-input-color-picker [hidden]="annotationLabelBackgroundForm.value.opacity === 0"
        [control]="annotationLabelBackgroundForm.controls.color"
        [label]="'global.background_color'"
        [class]="'w-full'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
      <!-- Background Opacity -->
      <medsurf-design-form-control-input-slider [hidden]="annotationLabelBackgroundForm.value.opacity === 0"
        [control]="annotationLabelBackgroundForm.controls.opacity"
        [label]="'global.background_opacity'"
        [class]="'w-full'"
        [isPercentage]="true"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-slider>
    </div>
  </medsurf-design-form-control-form>
}

<!-- Annotation Label Form -->
@if (annotationLabelForm) {
  <medsurf-design-form-control-form
    [formGroup]="annotationLabelForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <!-- Font Size -->
      <medsurf-design-form-control-input-number [hidden]="(slideAuthorFacade.currentSelectedSlideFreeFormIsLine$ | async) === true || (slideAuthorFacade.currentSelectedSlideFreeFormIsFree$ | async) === true"
        [control]="annotationLabelForm.controls.fontSize"
        [label]="'global.font_size'"
        [class]="'w-full'"
        [min]="1"
        [max]="100"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
      <div [hidden]="(slideAuthorFacade.currentSelectedSlideFreeFormIsLine$ | async) === true || (slideAuthorFacade.currentSelectedSlideFreeFormIsFree$ | async) === true || (slideAuthorFacade.currentSelectedSlideFreeFormIsShape$ | async) === true"
        class="flex flex-row flex-wrap align-items-start w-full">
        <!-- Align -->
        <medsurf-design-form-control-input-select-button [control]="annotationLabelForm.controls.align"
          [options]="FlatModels.AnnotationLabelEntityModels.AnnotationLabelAlignArray"
          [optionIcons]="FlatModels.AnnotationLabelEntityModels.AnnotationLabelAlignIcon"
          [showOptionLabel]="false"
          [allowEmpty]="false"
        (valueChange)="onSubmit()"></medsurf-design-form-control-input-select-button>
        <!-- Pivot -->
        <medsurf-design-form-control-input-pivot [control]="annotationLabelForm.controls.pivot"
          [class]="'flex-1'"
        (valueChange)="onSubmit()"></medsurf-design-form-control-input-pivot>
      </div>
    </div>
  </medsurf-design-form-control-form>
}
